<template>
  <div>
    <h3 class="u-mb-20">{{ id ? 'Editar nutriente' : 'Novo nutriente' }}</h3>

    <el-form :model="dados" ref="form" label-position="top">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="12">
          <el-form-item label="Nome" prop="nome">
            <el-input v-model="dados.nome" placeholder="Ex.: Ferro"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="6">
          <el-form-item label="Sigla">
            <el-input v-model="dados.sigla" placeholder="Fe"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="6">
          <el-form-item label="Unidade" prop="unidade">
            <el-select v-model="dados.unidade" allow-create filterable placeholder="mg" style="width:100%">
              <el-option label="mg" value="mg"></el-option>
              <el-option label="µg" value="µg"></el-option>
              <el-option label="g" value="g"></el-option>
              <el-option label="UI" value="UI"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="Descrição">
        <el-input v-model="dados.descricao" type="textarea" :rows="3"></el-input>
      </el-form-item>

      <el-form-item label="Ativo">
        <el-switch v-model="dados.situacao"></el-switch>
      </el-form-item>

      <div class="u-text-right u-mt-20">
        <router-link to="/admin/merenda/nutriente" class="u-mr-10">
          <el-button>CANCELAR</el-button>
        </router-link>
        <el-button type="primary" @click="salvar">SALVAR</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  data: () => ({
    id: null,
    dados: { nome: '', sigla: '', unidade: '', descricao: '', situacao: true }
  }),
  mounted () {
    this.id = this.$route.params.id || null
    if (this.id) this.carregar()
  },
  methods: {
    carregar () {
      window.eventBus.$emit('loading', true)
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/nutriente/getById/` + this.id, this.$store.getters.getHeaderAuth)
        .then(response => {
          window.eventBus.$emit('loading', false)
          if (response.data && response.data.erro) {
            return window.eventBus.$emit('alert', { msg: response.data.erro, type: 'warning' })
          }
          this.dados = response.data
        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
    },
    salvar () {
      window.eventBus.$emit('loading', true)
      const url = this.id
        ? `${this.$store.state.config.baseUrlApi}/api/merenda/nutriente/update/` + this.id
        : `${this.$store.state.config.baseUrlApi}/api/merenda/nutriente/store`

      this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth)
        .then(response => {
          window.eventBus.$emit('loading', false)
          if (response.data && response.data.erro) {
            return window.eventBus.$emit('alert', { msg: response.data.erro, type: 'warning' })
          }
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.$router.push('/admin/merenda/nutriente')
        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
    }
  }
}
</script>
